<template lang="pug">
  el-container(id="NetworkList-container")
    el-card.el-card-margin-4.el-card-full-width.el-card-full-height-with-scroll
      el-header(id="NetworkList-header" height='40px') {{$t('Network list')}}
      .row.header
        .cell.network.header
          .name {{ $t('Network') }}
          el-input.input(id="NetworkList-nameSearchInput" v-model='nameSearch', size='mini', type='text', clearable)
        .cell.client.header
          .name {{ $t('Client') }}
          el-input.input(id="NetworkList-clientSearchInput" v-model='clientSearch', size='mini', type='text', clearable)
        .cell.coversion.header {{ $t('Conversion profile') }}
        .cell.valid-to.header {{ $t('Valid To') }}
        .cell.buttons.header {{ $t('') }}
          el-button-group
            el-button.el-button--mini.float-right(
              id="NetworkList-addNetworkButton",
              type='success',
              icon='el-icon-plus',
              @click='handleAdd()'
            )
            el-button.el-button--mini.float-right(
              id="NetworkList-displayDeletedNetworksButton",
              :type='viewDeleted ? "success" : "info"',
              icon='el-icon-delete',
              :title='viewDeleted ? $t("Hide deleted") : $t("Show deleted")',
              @click='toggleDeletedView()'
            )
      .row(v-for="network of networks", :key='network.id', :id="'NetworkList-listRow' + network.id", :class='{ "danger": network.deleted }')
        .cell.network(:class='{"test-network": network.test, "danger": network.deleted}') {{ network.name}}
        .cell.client {{ network.Client.name}}
        .cell.conversion {{ network.conversionProfile }}
        .cell.valid-to
          span(v-if='network.validTo.length') {{ $moment(network.validTo).format('YYYY-MM-DD') }}
          span(v-else)
            font-awesome-icon(icon="infinity")
        .cell.buttons
          el-button-group
            el-button(
              :id="'NetworkList-editNetwork' + network.id + 'Button'",
              type="success",
              @click="handleEdit(network)",
              :title="$t('Edit network')",
              size="mini"
            )
              font-awesome-icon.float-right.button(:title='$t("Select network")', icon="edit")
            el-button(
              :id="'NetworkList-enterNetwork' + network.id + 'Button'",
              type="success",
              @click="handleSelectNetwork(network)",
              :title="$t('Enter network')",
              size="mini"
            )
              font-awesome-icon.float-right.button(:title='$t("Select network")', icon="sign-in-alt")
    NetworkEdit(:networkId="editedNetworkId", :editDialogVisible="editDialogVisible", @closeEditDialog="handleCloseEditDialog()")
</template>

<script>
import NetworkEdit from './NetworkEdit'

export default {
  props: ['side'],
  components: { NetworkEdit },
  created () {
    this.$store.dispatch('Network/getData')
  },
  data () {
    return {
      errors: {},
      editDialogVisible: false,
      editedNetworkId: undefined,
      nameSearch: '',
      clientSearch: '',
      viewDeleted: false
    }
  },
  methods: {
    toggleDeletedView () {
      this.viewDeleted = !this.viewDeleted
    },
    handleAdd () {
      this.editedNetworkId = 0
      this.editDialogVisible = true
    },
    handleEdit (row) {
      this.editedNetworkId = row.id
      this.editDialogVisible = true
    },
    // FIXME DRY
    async handleSelectNetwork (newNetwork) {
      if (!this.$store.state.User.user.Networks.find(network => network.id === newNetwork.id)) {
        await this.$store.dispatch('User/addNetworkToAdminNetworks', newNetwork)
      }
      this.$emit('changeNetwork', newNetwork.id)
    },
    handleCloseEditDialog (result) {
      this.editedNetworkId = null
      this.editDialogVisible = false
    }
  },
  computed: {
    networks () {
      let networksFiltered = JSON.parse(JSON.stringify(this.$store.state.Network.network_list))
      networksFiltered = this.nameSearch !== '' ? networksFiltered.filter(net => net.name.toLowerCase().indexOf(this.nameSearch.toLowerCase()) > -1) : networksFiltered
      networksFiltered = this.clientSearch !== '' ? networksFiltered.filter(net => net.Client.name.toLowerCase().indexOf(this.clientSearch.toLowerCase()) > -1) : networksFiltered
      networksFiltered = !this.viewDeleted ? networksFiltered.filter(net => net.deleted !== true) : networksFiltered
      return networksFiltered.sort((a, b) => a.name.localeCompare(b.name))
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.row {
  display: flex;
  font-size: $--font-size-base;
  padding: 10px 0px;
  &.header {
    color: $--color-text-secondary;
  }
  .cell {
    width: calc((100% - 55px)/3);
    border-bottom: $--border-light;
    // border: 1px dotted pink;
    &.header {
      display: flex;
      align-items: center;
      justify-content: left;
      border-bottom: 2px solid $--color-primary;
      margin-bottom: 15px;
      padding-bottom: 15px;
      .name {
        margin-right: 15px;
      }
      .input {
        max-width: 100px;
      }
    }
    &.buttons {
      text-align: right;
      width: 125px;
    }
    &.client {
      .row-inner {
        color: $--color-text-secondary;
        margin-left: 10px;
      }
    }
  }
  .test-network {
    color: $--color-text-regular-green;
    &.danger {
      color: $--color-danger;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Network/List.vue